"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_router_dom_1 = require("react-router-dom");
const common_styled_components_1 = require("../../common-styled-components");
const useFetch_1 = __importDefault(require("../../../hooks/useFetch"));
const compliance_pool_types_1 = require("../compliance-pool-types");
const apiUtils_1 = require("../../../util/apiUtils");
const MultiNumberKPI_1 = __importDefault(require("../common/MultiNumberKPI"));
const compliance_1 = require("../../../util/compliance/compliance");
const useMetadata_1 = require("../../../hooks/useMetadata");
const util_1 = require("../util");
const theme_1 = require("../../../theme");
const LineChart_1 = __importDefault(require("../LineChart"));
const log_1 = require("../../../util/log");
const TransactionTable_1 = require("../common/tables/TransactionTable");
const VoyageTable_1 = require("../common/tables/VoyageTable");
const routes_1 = require("../../../util/routes");
const BalancePlanTable_1 = require("../common/tables/BalancePlanTable");
const isNonEmptyObject_1 = require("../../../util/isNonEmptyObject");
const NavigationContext_1 = require("../../../contexts/NavigationContext");
const TransactionSummary_1 = require("../common/TransactionSummary");
const YearContext_1 = require("../../../contexts/YearContext");
const react_1 = require("react");
const TransactionAttachments_1 = require("./TransactionAttachments");
const VoyageBarChart_1 = __importDefault(require("./VoyageBarChart"));
const Modal_1 = require("../common/Modal");
const useEdit_1 = __importDefault(require("../../../hooks/useEdit"));
const lodash_1 = require("lodash");
exports.default = () => {
    const { shipId } = (0, react_router_dom_1.useParams)();
    const [metadata] = (0, useMetadata_1.useMetadata)();
    const { selectedYear } = (0, YearContext_1.useYear)();
    const [modal, setModal] = (0, react_1.useState)({});
    const [ship, _setShipUrl, _setShipBody, refreshShip] = (0, useFetch_1.default)("admin/ships.json", undefined, true);
    const [editStatus, executeEdit] = (0, useEdit_1.default)("admin/ship.json", refreshShip);
    const [voyages, _setVoyagesUrl, _setVoyagesBody, refreshVoyages] = (0, useFetch_1.default)("admin/voyages.json", undefined, true);
    const [plans, _setPlansUrl, _setPlansBody, refreshPlans] = (0, useFetch_1.default)("admin/balance_plans.json", JSON.stringify({ ship_id: Number(shipId) }));
    const [usageAnalysis, _setAnalysisUrl, _setAnalysisBody, refreshAnalysis] = (0, useFetch_1.default)("admin/ship_fuel_usage.json", undefined, true);
    const [transactionAttachments, _setAttachmentsUrl, _setAttachmentsBody, refreshAttachments,] = (0, useFetch_1.default)("admin/get_transaction_attachments.json", undefined, true);
    (0, react_1.useEffect)(() => {
        _setShipBody(JSON.stringify({
            ship_id: Number(shipId),
            year: selectedYear,
        }));
        _setVoyagesBody(JSON.stringify({
            ship_id: Number(shipId),
            year: selectedYear,
        }));
        _setAnalysisBody(JSON.stringify({
            ship_id: Number(shipId),
            year: selectedYear,
        }));
        _setAttachmentsBody(JSON.stringify({ ship_id: Number(shipId), year: selectedYear }));
    }, [selectedYear]);
    // const [bioDiesel, _setBioDieselUrl, setBioDieselBody] = useFetch<Calculation>(
    //   "calculator/cost-comparison",
    //   undefined,
    //   true
    // );
    // useEffect(() => {
    //   if (
    //     usageData &&
    //     isForecast(usageData.ship.forecast) &&
    //     usageData.ship.forecast.total.adjusted_emission_balance_ton < 0 &&
    //     metadata &&
    //     bioDiesel.status === LoaderStatus.Idle
    //   ) {
    //     const bodyBasis: Partial<FleetCalculatorParams> = {
    //       fleet_size: 1,
    //       year: currentYear,
    //       fuels: usageData.ship.forecast.forecast_fuels.map((fuelAmount) => {
    //         console.log(fuelAmount.fuel, metadata.fuels[fuelAmount.fuel]);
    //         return {
    //           engine_type: fuelAmount.engine_type,
    //           fuel_type: fuelAmount.fuel,
    //           foc: fuelAmount.amount,
    //           fuel_price:
    //             mockFuelPrices[fuelAmount.fuel] ??
    //             metadata.fuels[fuelAmount.fuel].price,
    //         };
    //       }),
    //     };
    //     // const engineTypes = chain(usageData.ship.forecast.forecast_fuels)
    //     //   .map((d) => d.engine_type)
    //     //   .uniq()
    //     //   .valueOf();
    //     const iceFuels = [24];
    //     const bodyB30 = {
    //       ...bodyBasis,
    //       comparison_fuels: iceFuels.map((f) => ({
    //         engine_change_cost: 0,
    //         engine_type: 1,
    //         fuel_price: mockFuelPrices[f] ?? metadata.fuels[f]?.price,
    //         fuel_type: f,
    //         engine_efficiency: metadata["efficiency-fuel-engine"][f][1],
    //         intensity: metadata["intensity-fuel-engine"][f][1],
    //       })),
    //     };
    //     setBioDieselBody(JSON.stringify(bodyB30));
    //   }
    // }, [usageAnalysis.status, metadata]);
    if (ship.status !== apiUtils_1.LoaderStatus.Success ||
        voyages.status !== apiUtils_1.LoaderStatus.Success ||
        usageAnalysis.status !== apiUtils_1.LoaderStatus.Success ||
        transactionAttachments.status !== apiUtils_1.LoaderStatus.Success ||
        !metadata) {
        return (0, jsx_runtime_1.jsx)(common_styled_components_1.PageContent, { children: "Loading\u2026" });
    }
    const shipData = ship.data[0];
    const voyageData = voyages.data;
    const usageData = usageAnalysis.data;
    const transactionAttachmentData = transactionAttachments.data;
    const refreshTransactionAttachmentsAndAnalysis = () => {
        refreshAttachments();
        refreshAnalysis();
    };
    const openEditShipModal = () => {
        setModal({
            type: "edit",
            value: shipData,
        });
    };
    const submitShip = (type, value) => {
        if (type !== "edit") {
            return;
        }
        const shipInput = (0, lodash_1.pick)(value, compliance_pool_types_1.shipInputKeys);
        if ((0, compliance_pool_types_1.isValidShipInput)(shipInput)) {
            setModal({});
            executeEdit(shipInput, "PUT");
        }
        else {
            alert("Ship not valid");
        }
    };
    (0, log_1.log)([
        // {
        //   label: "Metadata",
        //   content: metadata,
        // },
        // {
        //   label: "Ship",
        //   content: shipData,
        // },
        // {
        //   label: "Balance plans",
        //   content: plans.status === LoaderStatus.Success ? plans.data : "loading",
        // },
        // {
        //   label: "Usage analysis",
        //   content: usageData,
        // },
        // {
        //   label: "BioDiesel calculation",
        //   content:
        //     bioDiesel.status === LoaderStatus.Success ? bioDiesel.data : "loading",
        // },
        // {
        //   label: "Voyages",
        //   content: voyageData,
        // },
        {
            label: "Transaction attachments",
            content: transactionAttachmentData,
        },
        {
            label: "Compliance transactions",
            content: usageData.ship.transactions,
        },
    ]);
    if (!shipData) {
        return (0, jsx_runtime_1.jsx)(common_styled_components_1.PageContent, { children: "Ship not found!" });
    }
    const analysis = usageData.ship.analysis;
    const transactions = usageData.ship.transactions;
    const poiData = transactions.from
        .map((t) => (0, util_1.getTransactionPOI)(t, "from"))
        .concat(transactions.to.map((t) => (0, util_1.getTransactionPOI)(t, "to")));
    const forecastsAvailable = (0, compliance_pool_types_1.isForecast)(usageData.ship.forecast) &&
        usageData?.ship.forecast.forecast !== undefined &&
        usageData.ship.forecast.total !== undefined &&
        (0, compliance_pool_types_1.isIntensities)(usageData.ship.forecast.forecast);
    const forecastFuels = forecastsAvailable
        ? (0, util_1.combineFuels)(usageData.ship.forecast.forecast_fuels_total)
        : undefined;
    const forecastDate = forecastsAvailable
        ? new Date(usageData.ship.forecast.end)
        : undefined;
    const complianceBalance = analysis.intensities.total.adjusted_emission_balance_ton;
    const complianceState = (0, compliance_1.getCompliance)(complianceBalance);
    const complianceColor = compliance_1.complianceOptions[complianceState].color;
    const currentComplianceItems = [
        {
            color: complianceColor,
            value: (0, util_1.scaleEmissions)(complianceBalance),
            title: "Carbon units",
            subtitle: "With transactions, report-based",
            showPositiveSign: true,
            unit: analysis.intensities.total.adjusted_emission_balance_ton < 0
                ? "tCO₂e deficit"
                : "tCO₂e to spare",
        },
        {
            color: complianceColor,
            value: analysis.intensities.total.adjusted_intensity_gCO2e_per_MJ,
            title: "Carbon intensity",
            subtitle: "With transactions, report-based",
            unit: "gCO₂e/MJ",
            digits: 2,
        },
    ];
    const plansTotalBalance = plans.status === apiUtils_1.LoaderStatus.Success && plans.data
        ? plans.data.reduce((acc, p) => acc + (p.balance ?? 0), 0)
        : undefined;
    const forecastEOYBalance = forecastsAvailable && usageData.ship.forecast
        ? usageData.ship.forecast.total.adjusted_emission_balance_ton
        : undefined;
    const transactionsNet = (transactions.to?.reduce((s, t) => s + (t.quantity ?? 0), 0) ?? 0) -
        (transactions.from?.reduce((s, t) => s + (t.quantity ?? 0), 0) ?? 0);
    const forecastSource = shipData.pool[selectedYear]?.forecast_source;
    const forecastSourceLabel = compliance_pool_types_1.forecastSourceOptions.find((o) => o.value === forecastSource)?.label ??
        "Not set";
    const eoyItems = [
        {
            color: theme_1.theme.colors.blackText,
            value: plansTotalBalance,
            title: "Ship's balance plan",
            unit: "tCO₂e",
            digits: 2,
            showPositiveSign: true,
        },
        {
            color: theme_1.theme.colors.blackText,
            value: forecastEOYBalance !== undefined
                ? (0, util_1.scaleEmissions)(forecastEOYBalance)
                : undefined,
            title: "Forecast EOY balance",
            unit: "tCO₂e",
            showPositiveSign: true,
        },
        {
            color: theme_1.theme.colors.blackText,
            value: transactionsNet,
            title: "Transactions (net)",
            unit: "tCO₂e",
            digits: 2,
            showPositiveSign: true,
        },
    ];
    return ((0, jsx_runtime_1.jsxs)(common_styled_components_1.PageContent, { align: "left", children: [modal.type && ((0, jsx_runtime_1.jsx)(Modal_1.Modal, { type: "ship", isOpen: modal.type !== undefined, closeModal: () => setModal({}), modalType: modal.type, value: modal.value, submit: submitShip, pending: editStatus.status === apiUtils_1.LoaderStatus.Loading })), (0, jsx_runtime_1.jsxs)(common_styled_components_1.ContentGrid, { children: [(0, jsx_runtime_1.jsxs)(common_styled_components_1.GridCard, { children: [(0, jsx_runtime_1.jsx)(common_styled_components_1.TitleWithExtraContent, { titleLevel: "Section", extraContent: (0, jsx_runtime_1.jsx)(common_styled_components_1.Button, { onClick: openEditShipModal, children: "Edit" }), children: shipData.name }), (0, jsx_runtime_1.jsxs)(common_styled_components_1.PTight, { children: [(0, jsx_runtime_1.jsx)(common_styled_components_1.Bold, { children: "Vessel name: " }), shipData.name] }), (0, jsx_runtime_1.jsxs)(common_styled_components_1.PTight, { children: [(0, jsx_runtime_1.jsx)(common_styled_components_1.Bold, { children: "IMO: " }), shipData.imo] }), (0, jsx_runtime_1.jsxs)(common_styled_components_1.PTight, { children: [(0, jsx_runtime_1.jsx)(common_styled_components_1.Bold, { children: "Verifier: " }), shipData.verifier ?? "N/A"] }), (0, jsx_runtime_1.jsxs)(common_styled_components_1.PTight, { children: [(0, jsx_runtime_1.jsx)(common_styled_components_1.Bold, { children: "Pool: " }), (0, jsx_runtime_1.jsx)(NavigationContext_1.LinkWithHistory, { to: `${routes_1.routeNames.admin}/${routes_1.routeNames.pool}/${shipData.pool[selectedYear]?.pool_id}`, children: shipData.pool[selectedYear]?.pool_name ?? "N/A" })] })] }), (0, jsx_runtime_1.jsx)(common_styled_components_1.GridCard, { children: (0, jsx_runtime_1.jsx)(MultiNumberKPI_1.default, { items: currentComplianceItems }) }), (0, jsx_runtime_1.jsx)(common_styled_components_1.GridCard, { children: (0, jsx_runtime_1.jsx)(MultiNumberKPI_1.default, { items: eoyItems }) })] }), (0, jsx_runtime_1.jsxs)(common_styled_components_1.ContentGrid, { "$cols": 2, children: [(0, jsx_runtime_1.jsx)(common_styled_components_1.GridCard, { children: (0, jsx_runtime_1.jsx)(LineChart_1.default, { title: "Ship carbon intensity", unit: "gCO\u2082e/MJ", data: (poiData.length
                                ? [
                                    {
                                        name: "Intensity without transactions",
                                        color: theme_1.theme.colors.grey(2),
                                        data: analysis.intensities.cumulative?.map((d) => ({
                                            date: new Date(d.date),
                                            value: d.intensity.intensity_gCO2e_per_MJ,
                                        })) ?? [],
                                        prediction: forecastsAvailable && forecastDate
                                            ? {
                                                date: forecastDate,
                                                value: usageData.ship.forecast.total
                                                    .intensity_gCO2e_per_MJ,
                                            }
                                            : undefined,
                                    },
                                ]
                                : []).concat([
                                {
                                    name: "Intensity",
                                    color: theme_1.theme.colors.blackText,
                                    data: analysis.intensities.cumulative?.map((d) => ({
                                        date: new Date(d.date),
                                        value: d.intensity.adjusted_intensity_gCO2e_per_MJ,
                                    })) ?? [],
                                    prediction: forecastsAvailable && forecastDate
                                        ? {
                                            date: forecastDate,
                                            value: usageData.ship.forecast.total
                                                .adjusted_intensity_gCO2e_per_MJ,
                                        }
                                        : undefined,
                                },
                            ]), poiData: poiData, poiDataSetName: "Intensity", limits: [
                                {
                                    label: `${selectedYear} limit`,
                                    value: metadata.intensity[selectedYear],
                                    color: theme_1.theme.colors.red,
                                },
                            ] }) }), (0, jsx_runtime_1.jsxs)(common_styled_components_1.GridCard, { children: [(0, jsx_runtime_1.jsx)(LineChart_1.default, { title: "Carbon balance", unit: "tCO\u2082e to spare", data: (poiData.length
                                    ? [
                                        {
                                            name: "Balance without transactions",
                                            color: theme_1.theme.colors.grey(2),
                                            data: analysis.intensities.cumulative?.map((d) => ({
                                                date: new Date(d.date),
                                                value: d.intensity.emission_balance_ton,
                                            })) ?? [],
                                            prediction: forecastsAvailable && forecastDate
                                                ? {
                                                    date: forecastDate,
                                                    value: usageData.ship.forecast.total
                                                        .emission_balance_ton,
                                                }
                                                : undefined,
                                        },
                                    ]
                                    : []).concat([
                                    {
                                        name: "Carbon unit balance",
                                        color: theme_1.theme.colors.blackText,
                                        data: analysis.intensities.cumulative?.map((d) => ({
                                            date: new Date(d.date),
                                            value: d.intensity.adjusted_emission_balance_ton,
                                        })) ?? [],
                                        prediction: forecastsAvailable && forecastDate
                                            ? {
                                                date: forecastDate,
                                                value: usageData.ship.forecast.total
                                                    .adjusted_emission_balance_ton,
                                            }
                                            : undefined,
                                    },
                                ]), limits: plansTotalBalance
                                    ? [
                                        {
                                            label: "Balance plan (without transactions)",
                                            value: plansTotalBalance,
                                            color: theme_1.theme.colors.green,
                                        },
                                    ]
                                    : undefined, poiData: poiData, poiDataSetName: "Carbon unit balance" }), (0, jsx_runtime_1.jsxs)(common_styled_components_1.PSmall, { children: ["Forecast source: ", forecastSourceLabel, " (edit in ship editor)"] })] }), (0, jsx_runtime_1.jsx)(common_styled_components_1.GridCard, { children: (0, jsx_runtime_1.jsx)(LineChart_1.default, { title: "Cumulative emissions", unit: "tCO\u2082e", data: (poiData.length
                                ? [
                                    {
                                        name: "Emissions without transactions",
                                        color: theme_1.theme.colors.grey(2),
                                        dashed: false,
                                        data: analysis.intensities.cumulative?.map((d) => ({
                                            date: new Date(d.date),
                                            value: d.intensity.co2_emission_ton,
                                        })) ?? [],
                                        prediction: forecastsAvailable && forecastDate
                                            ? {
                                                date: forecastDate,
                                                value: usageData.ship.forecast.total.co2_emission_ton,
                                            }
                                            : undefined,
                                    },
                                ]
                                : []).concat([
                                {
                                    name: "Emissions",
                                    color: theme_1.theme.colors.blackText,
                                    dashed: false,
                                    data: analysis.intensities.cumulative?.map((d) => ({
                                        date: new Date(d.date),
                                        value: d.intensity.adjusted_co2_emission_ton,
                                    })) ?? [],
                                    prediction: forecastsAvailable && forecastDate
                                        ? {
                                            date: forecastDate,
                                            value: usageData.ship.forecast.total
                                                .adjusted_co2_emission_ton,
                                        }
                                        : undefined,
                                },
                                {
                                    name: "Emission limit",
                                    color: theme_1.theme.colors.red,
                                    dashed: true,
                                    data: analysis.intensities.cumulative?.map((d) => ({
                                        date: new Date(d.date),
                                        value: d.intensity.emission_limit_ton,
                                    })) ?? [],
                                    prediction: forecastsAvailable && forecastDate
                                        ? {
                                            date: forecastDate,
                                            value: usageData.ship.forecast.total.emission_limit_ton,
                                        }
                                        : undefined,
                                },
                            ]), poiData: poiData, poiDataSetName: "Emissions" }) }), analysis.fuel_spent.cumulative_fuel_timeline &&
                        (0, isNonEmptyObject_1.isNonEmptyObject)(analysis.fuel_spent.cumulative_fuel_timeline) && ((0, jsx_runtime_1.jsx)(common_styled_components_1.GridCard, { children: (0, jsx_runtime_1.jsx)(LineChart_1.default, { title: "Cumulative fuel use", unit: "t", data: Object.keys(analysis.fuel_spent.cumulative_fuel_timeline).map((fuelKey, i) => {
                                const fuelData = analysis.fuel_spent.cumulative_fuel_timeline[fuelKey];
                                return {
                                    name: metadata.fuels[fuelData.fuel]?.description ??
                                        "Name not found",
                                    color: (0, util_1.getFuelColor)(fuelData.fuel),
                                    data: fuelData.timeline.map((d) => ({
                                        date: new Date(d.date),
                                        value: d.amount,
                                    })),
                                    prediction: forecastFuels && forecastDate
                                        ? {
                                            date: forecastDate,
                                            value: forecastFuels[fuelKey],
                                        }
                                        : undefined,
                                };
                            }) }) }))] }), (0, jsx_runtime_1.jsx)(common_styled_components_1.ContentGrid, { "$cols": 1 }), (0, jsx_runtime_1.jsx)(common_styled_components_1.ContentGrid, { "$cols": 1, children: (0, jsx_runtime_1.jsxs)(common_styled_components_1.GridCard, { children: [(0, jsx_runtime_1.jsx)(common_styled_components_1.SmallTitle, { style: { marginBottom: theme_1.theme.spacing(2) }, children: "Compliance transactions" }), (0, jsx_runtime_1.jsx)(TransactionAttachments_1.TransactionAttachments, { transactionAttachments: transactionAttachmentData, shipId: shipData.id, selectedYear: selectedYear, refresh: refreshTransactionAttachmentsAndAnalysis, isInAdminTools: true }), transactions?.from.length > 0 || transactions?.to.length > 0 ? ((0, jsx_runtime_1.jsx)(TransactionSummary_1.TransactionSummary, { transactions: transactions })) : null, transactions?.from.length > 0 && ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)(common_styled_components_1.SmallSubtitle, { style: { marginBottom: theme_1.theme.spacing(2) }, children: ["Compliance transactions from ", shipData.name] }), (0, jsx_runtime_1.jsx)(TransactionTable_1.TransactionTable, { transactions: transactions.from, complianceYear: selectedYear, poolId: shipData.pool[selectedYear]?.pool_id, refresh: refreshAnalysis, isInAdminTools: true })] })), transactions?.to.length > 0 && ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)(common_styled_components_1.SmallSubtitle, { style: {
                                        marginTop: theme_1.theme.spacing(2),
                                        marginBottom: theme_1.theme.spacing(2),
                                    }, children: ["Compliance transactions to ", shipData.name] }), (0, jsx_runtime_1.jsx)(TransactionTable_1.TransactionTable, { transactions: transactions.to, complianceYear: selectedYear, poolId: shipData.pool[selectedYear]?.pool_id, refresh: refreshAnalysis, isInAdminTools: true })] }))] }) }), plans.status === apiUtils_1.LoaderStatus.Success && plans.data ? ((0, jsx_runtime_1.jsx)(common_styled_components_1.ContentGrid, { "$cols": 1, children: (0, jsx_runtime_1.jsxs)(common_styled_components_1.GridCard, { children: [(0, jsx_runtime_1.jsx)(common_styled_components_1.SmallTitle, { style: { marginBottom: theme_1.theme.spacing(2) }, children: "Balance plans" }), (0, jsx_runtime_1.jsx)(BalancePlanTable_1.BalancePlanTable, { balancePlans: plans.data, metadata: metadata, shipId: shipData?.id ?? undefined, refresh: refreshPlans, isInAdminTools: true })] }) })) : undefined, (0, jsx_runtime_1.jsx)(common_styled_components_1.ContentGrid, { "$cols": 1, children: (0, jsx_runtime_1.jsxs)(common_styled_components_1.GridCard, { children: [(0, jsx_runtime_1.jsxs)(common_styled_components_1.SmallTitle, { style: { marginBottom: theme_1.theme.spacing(2) }, children: ["Reports: ", shipData.name] }), (0, jsx_runtime_1.jsx)(VoyageBarChart_1.default, { voyages: voyageData }), (0, jsx_runtime_1.jsx)(VoyageTable_1.VoyageTable, { voyages: voyageData, metadata: metadata, isInAdminTools: true, refresh: refreshVoyages })] }) })] }));
};
